import { useSession } from "@outschool/ui-auth";

import { useRequiresMembershipForEnrollment } from "../../subscriptions/hooks/useRequiresMembershipForEnrollment";

export default function useCDPMembershipModal() {
  const {
    requiresMembershipForEnrollment,
    requiresEsaMembershipForEnrollment
  } = useRequiresMembershipForEnrollment();

  const { currentUser } = useSession();

  const isMembershipNeeded =
    (requiresMembershipForEnrollment &&
      (!currentUser?.hasSubscription ||
        !currentUser?.canPayWithSubscriptionCredits) &&
      !currentUser?.hasEsaMembership) ||
    requiresEsaMembershipForEnrollment;

  const shouldShowCDPMembershipModal = isMembershipNeeded;

  return {
    shouldShowCDPMembershipModal
  };
}
